import React from 'react'

function Mentionslegales() {
    return (
        <div className='container mt-5 text-center ML'>
            <div className='mb-4'> 
                <h5 className='titreML'>Editeur du site :</h5>
                <p>Amera BOUDIA</p>
            </div>
            <div className='mb-4'>
                <h5 className='titreML'>Contact :</h5>
                <h6 className='titreML'>Mail</h6><p>amera.boudia84@gmail.com</p>
                <h6 className='titreML'>Téléphone</h6><p>06.58.70.71.83</p>
            </div>
            <div className='mb-4'>
                <h5 className='titreML'>Hébergeur du site :</h5>
                <p>Nom </p>
            </div>

        </div>
    )
}

export default Mentionslegales
